import { useId, useRef, useEffect } from "react";
import { InputWithLabelWrapper, TicketInfoLabel } from "../TicketInfoField/TicketInfoField.styled";
import { DescriptionContent } from "./DescriptionField.styled";

interface DescriptionFieldProps {
    displayValue: string;
}
export const DescriptionField = ({displayValue}: DescriptionFieldProps) => {
    const inputId = useId();
    const descriptionRef = useRef<HTMLTextAreaElement>();

    const handleFocus = () => {
        if(descriptionRef.current)
        {
            descriptionRef.current?.blur();
        }
    }

    useEffect( () => {
        if(descriptionRef.current) {
            descriptionRef.current.style.height = 'auto';
            descriptionRef.current.style.height = descriptionRef.current.scrollHeight + 'px';
        }
    }, [displayValue]);

    return (
        <InputWithLabelWrapper>
            <TicketInfoLabel htmlFor={inputId} size="medium">Description </TicketInfoLabel>
            <DescriptionContent 
                appearance="outline"
                size="medium"
                style={{whiteSpace: 'pre-wrap'}}
                readOnly
                value={String(displayValue)}
                id={inputId}
                ref={descriptionRef} 
                onFocus={handleFocus}/>
        </InputWithLabelWrapper>

    );
}